import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import "@/index.css";
import App from "@/App";
import { sentryPrivacyOptions } from "@/lib/sentryScrub";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
  // p0-security-nov2: no PII, tokens, query strings or GPS in events/breadcrumbs.
  ...sentryPrivacyOptions,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
